import { CreateTempUserResponseDto } from "@/data/dto/user/create-temp-user-response-dto";
import { CreateTempUserResponseEntity } from "@/domain/entity/user/create-temp-user-response-entity";
import { assertCreateTempUserResponseDto } from "@/utils/validation/generated/create-temp-user-response-dto.validator";

export class CreateTempUserInfoMapper {
  static toEntity(dto: CreateTempUserResponseDto): CreateTempUserResponseEntity {
    assertCreateTempUserResponseDto(dto);

    return {
      userId: dto.userId,
      userUuid: dto.userUuid,
      role: dto.role,
      screeningId: dto.screeningId ?? "",
      loginId: dto.loginId ?? "",
      hospitalCode: dto.hospitalCode ?? "",
    };
  }
}
